module.exports = __webpack_public_path__ + "static/media/press-yahoo@2x.fbf82f9c.jpg";